import { Component } from "@builder.io/sdk";

export const ciAppDemoFormConfig: Component = {
  name: "CI App Demo Form",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Transform Your Care Facility Today",
    },
    {
      name: "className",
      type: "string",
    },
  ],
};
